import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const ButtonCourse = styled(Link).attrs({ className: 'btn btn-transparent' })`
  width: 35% !important;
  margin-left: calc(50%);
  transform: translateX(-50%);
  margin-top: 15px !important;
`;
